<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="m7.00506 6h10.00004l-5.01 6.3zm-2.75-.39c2.02 2.59 5.75004 7.39 5.75004 7.39v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61h-13.91004c-.83 0-1.3.95-.79 1.61z"
    />
  </svg>
</template>
